var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject, bindable } from "aurelia-framework";
import { transient } from "aurelia-dependency-injection";
var CustomButton = /** @class */ (function () {
    function CustomButton(element) {
        var _this = this;
        this.element = element;
        this.type = "button";
        this.onClickOuterElement = function (event) {
            if (!_this.isCurrentOrChildElement(event.target, _this.button) || _this.disabled || _this.loading) {
                event.stopPropagation();
                event.preventDefault();
            }
        };
    }
    CustomButton.prototype.isCurrentOrChildElement = function (target, parent) {
        if (this.element == target)
            return false;
        if (target == parent)
            return true;
        return this.isCurrentOrChildElement($(target).parent().get(0), parent);
    };
    CustomButton.prototype.detached = function () {
        this.element.removeEventListener("click", this.onClickOuterElementCurrentContext);
    };
    CustomButton.prototype.attached = function () {
        // disables TabIndex if Disabled
        if (this.disabled) {
            this.tab = -1;
        }
        this.onClickOuterElementCurrentContext = this.onClickOuterElement.bind(this);
        this.element.addEventListener("click", this.onClickOuterElementCurrentContext);
    };
    CustomButton.prototype.onClickButtonElement = function (e) {
        if (this.disabled || this.loading) {
            e.stopPropagation();
        }
        else {
            var clickEvent = new CustomEvent("click", { detail: { fromCurrentElement: true } });
            this.element.dispatchEvent(clickEvent);
        }
    };
    CustomButton.prototype.disabledChanged = function () {
        if (this.disabled) {
            this.tab = -1;
        }
        else {
            this.tab = 0;
        }
    };
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], CustomButton.prototype, "type", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], CustomButton.prototype, "disabled", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], CustomButton.prototype, "loading", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], CustomButton.prototype, "background", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], CustomButton.prototype, "color", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Number)
    ], CustomButton.prototype, "tab", void 0);
    CustomButton = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [Element])
    ], CustomButton);
    return CustomButton;
}());
export { CustomButton };
